import axiosInstance from "../../../config/axios";

export interface RetailerAdvertisementPopup {
  id: number;
  title: string;
  description: string | null;
  webImages: string[];
  mobileImages: string[];
  redirectType: 'none' | 'url' | 'masterSearch';
  redirectUrl: string | null;
  inventors: string[];
  startDate: string | null;
  endDate: string | null;
  updatedAt: string;
}

// The one live pop-up for this retailer, or data: null when nothing is live.
export const getRetailerAdvertisementPopup = async () => {
  return axiosInstance.get<{ success: boolean; data: RetailerAdvertisementPopup | null }>(
    '/retailer/getAdvertisementPopup'
  );
};

// Called after the retailer closes or taps the pop-up; a nightly cron resets it.
export const markAdvertisementPopupRead = async () => {
  return axiosInstance.put('/retailer/advertisementPopup/read');
};

// Same retailers.popupRead flag as the login response, for sessions that are
// already signed in (persisted token) when a new day starts.
export const getAdvertisementPopupReadStatus = async () => {
  return axiosInstance.get<{ success: boolean; data: { popupRead: boolean } }>(
    '/retailer/advertisementPopup/readStatus'
  );
};

// Click tracking shared with banners/stories; deviceType is required for pop-ups.
export const trackAdvertisementPopupClick = async (popupId: number, deviceType: 'web' | 'mobile' = 'web') => {
  return axiosInstance.post('/retailer/record-click/track', {
    platform: 'popup',
    referenceId: popupId,
    deviceType,
  });
};
